module.exports = __webpack_public_path__ + "img/tsm-menu.9111045f.svg";